/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseTripTagInfo } from '../models/ApiResponseTripTagInfo';
import type { ApiResponseTripTagListResponse } from '../models/ApiResponseTripTagListResponse';
import type { ApiResponseTripTagsResponse } from '../models/ApiResponseTripTagsResponse';
import type { ApiResponseVoid } from '../models/ApiResponseVoid';
import type { CreateTagRequest } from '../models/CreateTagRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TripTagsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 커스텀 태그 이름 변경
   * 커스텀 태그의 이름을 변경합니다 (비즈니스 태그는 변경 불가)
   * @returns ApiResponseTripTagInfo OK
   * @throws ApiError
   */
  public renameTag({
    tagName,
    newTagName,
  }: {
    tagName: string,
    newTagName: string,
  }): CancelablePromise<ApiResponseTripTagInfo> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/trip-tags/{tagName}',
      path: {
        'tagName': tagName,
      },
      query: {
        'newTagName': newTagName,
      },
    });
  }
  /**
   * 커스텀 태그 삭제
   * 커스텀 태그를 삭제합니다 (비즈니스 태그는 삭제 불가, 연결된 모든 매핑도 함께 삭제됩니다)
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public deleteTag({
    tagName,
  }: {
    tagName: string,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/trip-tags/{tagName}',
      path: {
        'tagName': tagName,
      },
    });
  }
  /**
   * 태그 목록 조회
   * 비즈니스 태그 + 사용자 커스텀 태그를 조회합니다
   * @returns ApiResponseTripTagListResponse OK
   * @throws ApiError
   */
  public getAllTags(): CancelablePromise<ApiResponseTripTagListResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/trip-tags',
    });
  }
  /**
   * 커스텀 태그 생성
   * 새로운 커스텀 태그를 생성합니다 (비즈니스 태그는 생성 불가)
   * @returns ApiResponseTripTagInfo OK
   * @throws ApiError
   */
  public createTag({
    requestBody,
  }: {
    requestBody: CreateTagRequest,
  }): CancelablePromise<ApiResponseTripTagInfo> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/trip-tags',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 트립에 태그 추가
   * 주행이력에 태그를 추가합니다
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public addTagToTrip({
    vin,
    tripId,
    tagName,
  }: {
    vin: string,
    tripId: number,
    tagName: string,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/trip-tags/vehicle/{vin}/trip/{tripId}',
      path: {
        'vin': vin,
        'tripId': tripId,
      },
      query: {
        'tagName': tagName,
      },
    });
  }
  /**
   * 트립에 여러 태그 추가
   * 주행이력에 여러 태그를 일괄 추가합니다
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public addTagsToTrip({
    vin,
    tripId,
    requestBody,
  }: {
    vin: string,
    tripId: number,
    requestBody: Array<string>,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/trip-tags/vehicle/{vin}/trip/{tripId}/batch',
      path: {
        'vin': vin,
        'tripId': tripId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 트립의 태그 목록 조회
   * 주행이력에 연결된 모든 태그를 조회합니다
   * @returns ApiResponseTripTagsResponse OK
   * @throws ApiError
   */
  public getTagsForTrip({
    tripId,
  }: {
    tripId: number,
  }): CancelablePromise<ApiResponseTripTagsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/trip-tags/trips/{tripId}',
      path: {
        'tripId': tripId,
      },
    });
  }
  /**
   * 트립에서 태그 제거
   * 주행이력에서 태그를 제거합니다
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public removeTagFromTrip({
    tripId,
    vin,
    tagName,
  }: {
    tripId: number,
    vin: string,
    tagName: string,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/trip-tags/vehicle/{vin}/trips/{tripId}/tag/{tagName}',
      path: {
        'tripId': tripId,
        'vin': vin,
        'tagName': tagName,
      },
    });
  }
}
